export const EMAIL_VALIDATION_ERROR = {
    INVITE_YOURSELF: "rewards_modal.main_screen.invite_section.email_error.invite_yourself",
    WRONG_FORMAT: "rewards_modal.main_screen.invite_section.email_error.wrong_format",
    ALREADY_SUBSCRIBED: "rewards_modal.main_screen.invite_section.email_error.already_subscribed",
};

export interface EmailWithError {
    email: string;
    reason: (typeof EMAIL_VALIDATION_ERROR)[keyof typeof EMAIL_VALIDATION_ERROR];
}

export const BUTTON_WIDTH = "fit-content";
